import React from 'react';
import PropTypes from 'prop-types';

export default function BookmarksEmptyState({ illustrationUrl, imageUrl }) {
  return (
    <div className="empty-state-container">
      <img className="empty-state-illustration" src={illustrationUrl} alt="Saved wires icon and page" />
      <h3>You have no saved wires</h3>
      <p>
        Find the save icon (
        <span className="icon-lw icon-lw-bookmark" />
        ) on any wire to save.
      </p>
      <p>Manage your saved wires right here, on any device.</p>
      <img className="empty-state-image" src={imageUrl} alt="Saved wires instructional diagram" />
    </div>
  );
}

BookmarksEmptyState.propTypes = {
  illustrationUrl: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
};
